
export const SEND_OTP_FOR_FORGET_PASSWORD = "SEND_OTP_FOR_FORGET_PASSWORD"
export const SEND_OTP_FOR_FORGET_PASSWORD_SUCCESS = "SEND_OTP_FOR_FORGET_PASSWORD_SUCCESS"
export const SEND_OTP_FOR_FORGET_PASSWORD_ERROR = "SEND_OTP_FOR_FORGET_PASSWORD_ERROR"

export const CHANGE_PASSWORD_FOR_FORGET_PASSWORD = "CHANGE_PASSWORD_FOR_FORGET_PASSWORD"
export const CHANGE_PASSWORD_FOR_FORGET_PASSWORD_SUCCESS = "CHANGE_PASSWORD_FOR_FORGET_PASSWORD_SUCCESS"
export const CHANGE_PASSWORD_FOR_FORGET_PASSWORD_ERROR = "CHANGE_PASSWORD_FOR_FORGET_PASSWORD_ERROR"